import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HelmetProvider, Helmet } from 'react-helmet-async';
const googleFonts = [
    '"Montserrat", sans-serif',
    '"Lato", sans-serif',
    '"Roboto", sans-serif',
    '"Poppins", sans-serif',
    '"Lora", serif',
    '"Questrial", sans-serif',
    '"Host Grotesk", sans-serif',
];
const googleFontMapping = {
    '"Montserrat", sans-serif': 'Montserrat',
    '"Lato", sans-serif': 'Lato',
    '"Roboto", sans-serif': 'Roboto',
    '"Poppins", sans-serif': 'Poppins',
    '"Lora", serif': 'Lora',
    '"Questrial", sans-serif': 'Questrial',
    // Google Fonts API family slug (see fonts.google.com/specimen/Host+Grotesk)
    '"Host Grotesk", sans-serif': 'Host+Grotesk',
};
const getLinkImportsTag = (fontName) => (`
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=${fontName}:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap" rel="stylesheet">
  `);
const getComponentLinksTags = (fontName) => (_jsxs(_Fragment, { children: [_jsx("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }), _jsx("link", { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" }), _jsx("link", { rel: "stylesheet", href: `https://fonts.googleapis.com/css2?family=${fontName}:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap` })] }));
const mapFontTags = {
    '"Montserrat", sans-serif': getLinkImportsTag('Montserrat'),
    '"Lato", sans-serif': getLinkImportsTag('Lato'),
    '"Roboto", sans-serif': getLinkImportsTag('Roboto'),
    '"Poppins", sans-serif': getLinkImportsTag('Poppins'),
    '"Lora", serif': getLinkImportsTag('Lora'),
    '"Questrial", sans-serif': getLinkImportsTag('Questrial'),
    '"Host Grotesk", sans-serif': getLinkImportsTag('Host+Grotesk'),
};
const mapComponentsTags = {
    '"Montserrat", sans-serif': getComponentLinksTags('Montserrat'),
    '"Lato", sans-serif': getComponentLinksTags('Lato'),
    '"Roboto", sans-serif': getComponentLinksTags('Roboto'),
    '"Poppins", sans-serif': getComponentLinksTags('Poppins'),
    '"Lora", serif': getComponentLinksTags('Lora'),
    '"Questrial", sans-serif': getComponentLinksTags('Questrial'),
    '"Host Grotesk", sans-serif': getComponentLinksTags('Host+Grotesk'),
};
// Utility functions
export const isGoogleFont = (fontFamily) => googleFonts.includes(fontFamily);
export const getGoogleFontName = (fontFamily) => googleFontMapping[fontFamily] || null;
const getHeaderImportFontTags = (key) => {
    if (!googleFonts.includes(key)) {
        return '';
    }
    return mapFontTags[key];
};
const getHeaderComponentsFontTags = (key) => {
    if (!googleFonts.includes(key)) {
        return null;
    }
    return mapComponentsTags[key];
};
const PortalFontLoader = ({ children, fontFamily, }) => {
    if (!fontFamily) {
        return children;
    }
    const isGoogleFontFamily = googleFonts.includes(fontFamily);
    return (_jsxs(_Fragment, { children: [isGoogleFontFamily && (_jsx(HelmetProvider, { children: _jsx(Helmet, { children: getHeaderComponentsFontTags(fontFamily) }) })), children] }));
};
PortalFontLoader.defaultProps = {
    fontFamily: null,
};
export { googleFonts, getHeaderImportFontTags, getHeaderComponentsFontTags, PortalFontLoader, };
//# sourceMappingURL=RemoteTypography.js.map